import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-score-charts',
  templateUrl: './driver-score-charts.component.html',
  styleUrls: ['./driver-score-charts.component.css']
})
export class DriverScoreChartsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
